import React from 'react';

import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

import { ActionTypeEnum, LogsItem, TaskChange } from '../../types/interfaces';

interface TasksExpansionProps {
  rowData: LogsItem;
  addedItems: TaskChange[];
  deletedItems: TaskChange[];
  getTaskInfo: (rowData: LogsItem) => { taskId?: number; taskName?: string };
}

export const TasksExpansion: React.FC<TasksExpansionProps> = ({
  rowData,
  addedItems,
  deletedItems,
  getTaskInfo
}) => {
  const isTaskCreationOrDeletion =
    rowData.actionType === ActionTypeEnum.CREATETASK ||
    rowData.actionType === ActionTypeEnum.DELETETASK;

  const isDepartmentChanged =
    rowData.actionType === ActionTypeEnum.DEPARTMENTCHANGEDINTASK;

  if (isTaskCreationOrDeletion) {
    const actionLabel =
      rowData.actionType === ActionTypeEnum.CREATETASK
        ? 'Добавленные'
        : 'Удаленные';
    const typeLabel = 'наряды';
    const displayItems =
      rowData.actionType === ActionTypeEnum.CREATETASK
        ? addedItems
        : deletedItems;

    return (
      <div >
        <div>
          <h5 className="pl-2">
            {actionLabel} {typeLabel}
          </h5>
          <DataTable
            dataKey="taskId"
            value={displayItems.length > 0 ? displayItems : []}
            className="w-full mt-2 mb-4"
          >
            <Column
              columnKey="taskId"
              field="taskId"
              header="Наряд"
              body={(row: TaskChange) => {
                const taskInfo = getTaskInfo(rowData);
                const taskId = row.taskId || taskInfo.taskId;
                const isDeleted =
                  row.isDeleted === true ||
                  rowData.actionType === ActionTypeEnum.DELETETASK;

                if (!taskId) return <span>Наряд</span>;

                return (
                  <span
                    style={{
                      cursor: !isDeleted ? 'pointer' : 'default',
                      color: !isDeleted ? '#007ad9' : '#000'
                    }}
                    onClick={() => {
                      if (!isDeleted) {
                        window.open(`/${taskId}`, '_blank');
                      }
                    }}
                  >
                    Наряд №{taskId}
                  </span>
                );
              }}
              style={{ width: '21%' }}
            />
            <Column
              columnKey="department"
              field="department"
              header="Участок"
              body={(row: TaskChange) =>
                row.department || rowData.department || ''
              }
              style={{width: '44%'}}
            />
            <Column
              columnKey="taskLink"
              header=""
              body={() => {
                const taskInfo = getTaskInfo(rowData);
                const taskId = taskInfo.taskId;
                const anyDeleted =
                  addedItems.some(i => (i as TaskChange).isDeleted === true) ||
                  deletedItems.some(i => (i as TaskChange).isDeleted === true);
                const isDeleted =
                  anyDeleted || rowData.actionType === ActionTypeEnum.DELETETASK;
                if (!taskId) {
                  return <span style={{ color: '#999' }}>Нет # наряда</span>;
                }
                if (isDeleted) {
                  return (
                    <span style={{ color: '#999' }}>Наряд №{taskId} удален</span>
                  );
                }
                return (
                  <span
                    style={{ cursor: 'pointer', color: '#007ad9' }}
                    onClick={() => {
                      window.open(`/${taskId}?tab=history`, '_blank');
                    }}
                  >
                    Перейти к истории наряда №{taskId} 
                  </span>
                );
              }}
              style={{width: '35%'}}
            />
          </DataTable>
        </div>
      </div>
    );
  }

  if (isDepartmentChanged) {
    return (
      <div >
        <div>
          <h5 className="pl-2">Изменен участок в наряде</h5>
          {addedItems.length > 0 && deletedItems.length > 0 ? (
            <DataTable
              dataKey="taskId"
              value={addedItems}
              className="w-full mt-2 mb-4"
            >
              <Column
                columnKey="taskId"
                field="taskId"
                header="Наряд"
                body={(row: TaskChange) => {
                  const taskInfo = getTaskInfo(rowData);
                  const taskId = row.taskId || taskInfo.taskId;
                  const isDeleted =
                    row.isDeleted === true ||
                    rowData.actionType === ActionTypeEnum.DELETETASK;

                  if (!taskId) return <span>Наряд</span>;

                  return (
                    <span
                      style={{
                        cursor: !isDeleted ? 'pointer' : 'default',
                        color: !isDeleted ? '#007ad9' : '#000'
                      }}
                      onClick={() => {
                        if (!isDeleted) {
                          window.open(`/${taskId}`, '_blank');
                        }
                      }}
                    >
                      Наряд №{taskId}
                    </span>
                  );
                }}
                style={{ width: '21%' }}
              />
              <Column
                columnKey="department"
                header="Участок"
                body={(row: any) => {
                  const oldDept = (deletedItems[0] as TaskChange).department || '';
                  const newDept = row.department || '';
                  const changed = newDept && oldDept && oldDept !== newDept;
                  return (
                    <span>
                      {changed ? (
                        <>
                          {oldDept}
                          <i
                            className="pi pi-arrow-right"
                            style={{ margin: '0 0.5rem' }}
                          ></i>
                          {newDept}
                        </>
                      ) : (
                        newDept || oldDept || ''
                      )}
                    </span>
                  );
                }}
                style={{width: '44%'}}
              />
              <Column
                columnKey="taskLink"
                header=""
                body={() => {
                  const taskInfo = getTaskInfo(rowData);
                  const taskId = taskInfo.taskId;
                  const anyDeleted =
                    addedItems.some(i => (i as TaskChange).isDeleted === true) ||
                    deletedItems.some(i => (i as TaskChange).isDeleted === true);
                  if (!taskId) {
                    return <span style={{ color: '#999' }}>Нет # наряда</span>;
                  }
                  if (anyDeleted) {
                    return (
                      <span style={{ color: '#999' }}>Наряд №{taskId} удален</span>
                    );
                  }
                  return (
                    <span
                      style={{ cursor: 'pointer', color: '#007ad9' }}
                      onClick={() => {
                        window.open(`/${taskId}?tab=history`, '_blank');
                      }}
                    >
                      Перейти к истории наряда №{taskId}
                    </span>
                  );
                }}
              />
            </DataTable>
          ) : (
            <div >
              <p>Изменен участок в наряде</p>
              <p>
                {(() => {
                  const taskInfo = getTaskInfo(rowData);
                  const taskId = taskInfo.taskId;
                  const anyDeleted =
                    addedItems.some(i => (i as TaskChange).isDeleted === true) ||
                    deletedItems.some(i => (i as TaskChange).isDeleted === true);
                  if (!taskId) {
                    return (
                      <span style={{ color: '#999' }}>
                        Нет # наряда для перехода
                      </span>
                    );
                  }
                  if (anyDeleted) {
                    return (
                      <span style={{ color: '#999' }}>Наряд №{taskId} удален</span>
                    );
                  }
                  return (
                    <span
                      style={{ cursor: 'pointer', color: '#007ad9' }}
                      onClick={() => {
                        window.open(`/${taskId}?tab=history`, '_blank');
                      }}
                    >
                      Перейти к истории наряда №{taskId} #{taskId}
                    </span>
                  );
                })()}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  return null;
};

